import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: any = {}

const barrierFormValidationDataSlice = createSlice({
  name: 'formValidationData',
  initialState,
  reducers: {
    setFormValidationData: (state, action: PayloadAction<any>) => {
      Object.assign(state, action.payload)
    },
    removeFormValidationData: (state, action: PayloadAction<any>) =>{
      state.plant = {}
      state.management = {}
    }
  }
})

export const {
  setFormValidationData,
  removeFormValidationData
} = barrierFormValidationDataSlice.actions
export default barrierFormValidationDataSlice.reducer
